/*
 *******************************************************************************
 * 
 *  Filename:   ./shared/common/validation.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Shared functions for field level validation for redux-form.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Monday, September 10, 2018 - 10:30 PM (CST)
 *  
 *  Usage:      required() - must be non-blank
 *          
 *              maxLength(length as Integer) - must be <= length characters
 *              
 *              minLength(length as Integer) - must be >= length characters
 *              
 *              number() - must be a number
 *              
 *              maxValue(max) - must be <= max number
 *              
 *              minValue(min) - must be >= min number
 *              
 *              email() - must be valid email format
 *              
 *              nonZero() - must be a number greater than zero
 *              
 *              forceNumber() - used in parse argument to force select box value
 *              translation to be a number (0) instead of string ('0')
 *              <Input parse={req.forceNumber} />
 *              
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/10/2018  NJN     File Created
 *      09/15/2018  NJN     Added forceNumber - doesn't allow anything other
 *                          than numbers and needed for correct Dropdown/Select
 *                          operation - resets, validation. Used in parse prop,
 *                          not validation field.
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

const getIndexByName = (fields, name) => fields.findIndex(x => x.name === name)

const basic = {
    required: value => value ? undefined : 'Required value',
    maxLength: max => value => value && value.length > max ? `Must be ${max} characters or less` : undefined,
    minLength: min => value => value && value.length >= min ? undefined : `Must be ${min} characters or more`,
    number: value => value && isNaN(Number(value)) ? 'Must be a number' : undefined,
    maxValue: max => value => value && value > max ? `Must be ${max} or less` : undefined,
    minValue: min => value => value && value < min ? `Must be at least ${min}` : undefined,
    email: value => value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? 'Invalid email address' : undefined,
    nonZero: value => value > 0 ? undefined : 'Required value',
    forceNumber: value => isNaN(parseInt(value, 10)) ? null : parseInt(value, 10),
    maxChar: (value, values, props, name) => {
        const index = getIndexByName(props.fieldJSON, name);
        const maxLength = props.fieldJSON[index].maxLength;
        return value && value.length > maxLength ? `Must be ${maxLength} characters or less` : undefined
    }
};

export default {
    basic
};


// WEBPACK FOOTER //
// ./src/shared/common/validation.js